import {tsvParse} from "d3-dsv";
import text from "./text";

export default function(url, row) {
  return text(url).then(function(response) {
    return tsvParse(response, row);
  });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-fetch/src/tsv.js
// module id = 238
// module chunks = 0